/** @deprecated Use `| null` instead. */
export type Nullable<T> = T | null;

export type Maybe<T> = T | null | undefined;
export type MaybePartial<T> = Maybe<Partial<T>>;

export type MaybeProps<T> = {
  [key in keyof T]?: Maybe<T[key]>
};

export type NullableProps<T> = {
  [key in keyof T]?: T[key] | null;
};

export type RequiredProps<T> = {
  [P in keyof Required<T>]: NonNullable<T[P]>;
}

export type Enum = Record<string, string | number>;

/** Generic type for expressing a tuple that can be returned from an operation which can also return an error. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- `any` defaults are required for Result to allow flexible tuple typing without forcing callers to specify type params
export type Result<TResult = any, TError = any> =
  [TResult] |
  [TResult, null] |
  [null, TError];

export type Key = string | number | symbol;

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- `any` is required for mixin pattern Constructor to accept arbitrary constructor signatures
export type Constructor<T = {}> = new (...args: any[]) => T;

export function certifyType<T>(_arg: unknown): asserts _arg is T { /* noop */ }

export function isNullOrUndefined(arg: unknown): arg is null | undefined {
  return arg === null || arg === undefined;
}

export function isDefined<T>(arg: unknown): arg is Exclude<T, null | undefined> {
  return !isNullOrUndefined(arg);
}